import React, { useRef } from "react";
import { useTrans } from "system/translations/hooks";
import FormBuilder from "services/formBuilder/FormBuilder";
import {
  useGetMerchantWhiteListById,
  useUpdateMerchantWhiteList,
} from "modules/merchantWhiteList/apiHooks";
import { createEditValidation } from "modules/merchantWhiteList/validation";
import { useCreateEditConfig } from "modules/merchantWhiteList/constantHooks";
import Loader from "components/atoms/Loader";
import { createStyles } from "types/emotion-styles";
import themeOptions from "system/theme";
import { css } from "@emotion/react";
import ActionButtons from "components/atoms/ActionButtons";
import { useDrawer } from "services/drawer/hooks";
import Divider from "components/atoms/Divider";
import DrawerInfo from "./DrawerInfo";

const styles = createStyles({
  wrapper: {
    display: "grid",
    height: "100%",
    gridTemplateRows: "1fr 72px",
  },
  container: {
    padding: themeOptions.spacing.lg,
  },
  buttonsWrapper: {
    padding: themeOptions.spacing.md,
    borderTop: `1px solid ${themeOptions.colors.gray300}`,
    display: "grid",
    justifyContent: "flex-end",
  },
});

const Update: React.FC<{ merchantId: number; id: number }> = ({
  merchantId,
  id,
}) => {
  const { _t } = useTrans();
  const formikRef: any = useRef(null);
  const { hideDrawer } = useDrawer();
  const { mutate: onUpdate, isLoading: isUpdating } =
    useUpdateMerchantWhiteList(merchantId);
  const { data, isLoading } = useGetMerchantWhiteListById(merchantId, id);
  const formConfig = useCreateEditConfig();
  const onSubmit = async () => {
    formikRef?.current?.formik?.handleSubmit();
    if (formikRef?.current?.formik?.isValid) {
      const values = formikRef?.current?.formik?.values;
      await onUpdate({ data: values, id });
      hideDrawer();
    }
  };
  if (isLoading) {
    return <Loader formOverlay />;
  }

  return (
    <div css={css(styles.wrapper)}>
      <div css={styles.container}>
        <FormBuilder
          showSubmit={false}
          ref={formikRef}
          formItemsConfig={formConfig}
          formProps={{
            submitBtnLabel: _t("update"),
            onSubmit: onSubmit,
            initialValues: { ip: data?.ipAddress, comment: data?.comment },
            validationSchema: createEditValidation(_t, {
              isEdit: false,
            }),
          }}
        />
        <Divider/>
        <DrawerInfo />
      </div>
      <div css={styles.buttonsWrapper}>
        <ActionButtons
          onOkKind={"primary"}
          onOk={onSubmit}
          onCancel={hideDrawer}
          isLoading={isUpdating}
          onOkText={_t("save_changes")}
        />
      </div>
    </div>
  );
};

export default Update;
